import { SolutionSessionId } from '@backrs_ui/grow-ui/src/models/models';

export const finalMessages: Record<SolutionSessionId, { followups: string[] }> = {
  college_shortlist: {
    followups: [
      'Tell me more about why one of these may be a good fit?',
      'Get help with recommendation letters.',
      'Help me write my college essay.',
      'Help me improve my ACT or SAT.',
    ],
  },
  improve_your_test_scores: {
    followups: [
      'Develop a college shortlist for me',
      "Let's explore [a college]",
      'Give me tips for de-stressing',
    ],
  },
  lower_cost_of_college: {
    followups: [
      'Help me apply for one of these opportunities.',
      'Estimate the net price for my target school.',
      'Explain the Free Application for Federal Student Aid (FAFSA).',
      'Give me more ideas to reduce college costs.',
      'Estimate my Estimated Family Contribution (EFC).',
      'Create an action plan for me.',
    ],
  },
  jobs_you_might_love: {
    followups: [
      'What are my chances of landing one of these jobs?',
      'Improve my odds of landing one of these jobs',
      'Tell me more about a company',
      'Help me network',
    ],
  },
  common_threads: {
    followups: [
      'Tell me more about their career path',
      'Show me a few more related successful professionals',
      'Have they share any insights on [some topic]?',
    ],
  },
  letters_of_rec: {
    followups: ['Help me write my college essay.'],
  },
  what_are_your_chances: {
    followups: [
      'Help me write my college essay.',
      'Help me improve my ACT or SAT.',
      'Help me improve my resume.',
    ],
  },
  default: {
    followups: [''],
  },
};

export const sessionTitles: Record<SolutionSessionId, string> = {
  college_shortlist: 'Shortlist',
  improve_your_test_scores: 'Action Plan',
  lower_cost_of_college: 'Scholarships',
  jobs_you_might_love: 'Job Opportunities',
  common_threads: 'Commonalities',
  letters_of_rec: 'Letter',
  what_are_your_chances: 'Action Plan',
  default: 'Content',
};

export const sessionNames: Record<SolutionSessionId, string> = {
  college_shortlist: 'College Shortlist',
  improve_your_test_scores: 'Improve Your Test Scores',
  lower_cost_of_college: 'Lower the Cost of College',
  jobs_you_might_love: 'Jobs You Might Love',
  common_threads: 'Common Threads',
  letters_of_rec: 'Letter of Recommendation',
  what_are_your_chances: 'What are your chances?',
  default: 'Session',
} as const;

export const boxTitles: Record<SolutionSessionId, string[]> = {
  college_shortlist: ['Preferences', 'Academic Profile'],
  improve_your_test_scores: ['Scores', 'Profile'],
  lower_cost_of_college: ['Profile', 'Background'],
  jobs_you_might_love: ['Interests', 'Criteria'],
  common_threads: [],
  letters_of_rec: [],
  what_are_your_chances: [],
  default: ['Preferences', 'Profile'],
};
